import Helper from "../components/Helper";

export default class ReadMore {
    constructor()
    {
        this.init();
    }

    init()
    {
        // Create plugin
        (function ( $ ) {

            $.fn.readmore = function () {
                this.each(
                    function () {
                        let $element = $(this);
                        let $parent = $element.parent();
                        let parentHeight = $parent.innerHeight();

                        parentHeight -= parseInt($parent.css('padding-bottom')) + parseInt($parent.css('padding-top'));

                        // If the text is higher than parent (has overflown)
                        if (parentHeight < $element.actual('outerHeight')) {
                            let text = Helper.htmlEntityDecode($element.data('readmore') ?? '');
                            let parentPaddings = $parent.css(['padding-top', 'padding-bottom', 'padding-left', 'padding-right']);

                            /**
                             * Block of getting number of possible lines of text in element
                             */
                            let lineHeight = getIntFromPx(window.getComputedStyle(this, null).getPropertyValue('line-height'));
                            let possibleTextLines = parseInt(parentHeight / lineHeight);

                            /**
                             * Array with possible lines of strings
                             */
                            let possibleLinesArr = text.split('\n').slice(0, possibleTextLines);

                            /**
                             * Block of getting number of possible characters in one line of the element
                             */
                            let parentUseWidth = 0;

                            if ($element.data('modalReadmore') && window.innerWidth < 580) {
                                // modal margin 30 + inner padding 32 - has to do like this because the readmore is in
                                // modal and the width is always counted as on full width
                                parentUseWidth = window.innerWidth - 62;
                            } else {
                                parentUseWidth = $parent.actual('innerWidth') - getIntFromPx(parentPaddings['padding-left']) - getIntFromPx(parentPaddings['padding-right']);
                            }

                            $element.append('<span class="char-width-measure" data-width-meassure>x</span>');
                            let charWidth = $element.find('[data-width-meassure]').actual('outerWidth');
                            let possibleLineChars = parseInt(parentUseWidth / charWidth);

                            if (possibleLineChars <= 0) {
                                possibleLineChars = 1;
                            }

                            /**
                             * Block of combining lines of string to match maximum number of lines
                             */
                            let outputLines = [];
                            let regExp = new RegExp(`.{1,${possibleLineChars}}`, 'g');  // Split the string every n characters - regular expresion
                            let linesCount = 0;

                            for (let i = 0; i < possibleLinesArr.length; i++) {
                                // If the line text is longer then maximum possible characters that can fit the line
                                if (possibleLinesArr[i].length > possibleLineChars) {
                                    // Split the text and start appending each line to output
                                    let newLinesArr = possibleLinesArr[i].match(regExp); // Split the string every n characters - actual split

                                    for (let j = 0; j < newLinesArr.length; j++) {
                                        if (linesCount >= possibleTextLines) {
                                            break;  // If the maximum possible lines are already filled break
                                        }

                                        outputLines.push(newLinesArr[j]);
                                        linesCount += 1;
                                    }
                                } else {
                                    // Else the line text is shorter than maximum possible characters that can fit the line, can be appended
                                    outputLines.push(possibleLinesArr[i]);
                                    linesCount += 1;
                                }
                            }

                            /**
                             * Block of text completion
                             */
                            text = ($element.data('showAfterJs') === 1 || $element.data('joinBySpace') === 1) ? outputLines.join('') : outputLines.join('\n');
                            let $more = $parent.find('[data-readmore-link]');


                            if ($more.length > 0)
                                text = text.substr(0, text.length - $more.text().trim().length - 5).replace(/<\/?[^>]+(>|$)/g, "") + '...' + $more.parent().html();
                            else
                                text = text.substr(0, text.length - 3).replace(/<\/?[^>]+(>|$)/g, "") + '...';

                            $element.html(text);
                            $element.addClass('cropped');

                            if ($element.data('showAfterJs') === 1) {
                                $element.removeClass('white');

                                $parent.css({
                                    'height': 'unset'
                                })
                            }
                        }
                    }
                );
            }

            /**
             * This function will return number from px string in Integer format.
             *
             * @param {String} px
             * @returns {Number}
             */
            function getIntFromPx(px)
            {
                return parseInt(px.split('px')[0]);
            }

        }( jQuery ));
    }
}
